import { Controller } from "@hotwired/stimulus"

export default class FormValidationController extends Controller {
  static classes = ["validated"]
  validate(event) {
    if (!this.element.checkValidity()) {
      event.preventDefault()
      event.stopPropagation()
    }
    this.element.classList.add(this.validatedClass)
  }
}
